import axios from 'axios'
import OptionsTransformer from 'transformers/OptionsTransformer'

export default {
    getList() {
        return axios.get('insurance-plans', {
            transformResponse: [OptionsTransformer.transform('id', 'name')],
        })
    },
}
